import { render, staticRenderFns } from "./LayoutSwitch.vue?vue&type=template&id=150688cd&"
import script from "./LayoutSwitch.vue?vue&type=script&lang=js&"
export * from "./LayoutSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150688cd')) {
      api.createRecord('150688cd', component.options)
    } else {
      api.reload('150688cd', component.options)
    }
    module.hot.accept("./LayoutSwitch.vue?vue&type=template&id=150688cd&", function () {
      api.rerender('150688cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/category/LayoutSwitch.vue"
export default component.exports